// extracted by mini-css-extract-plugin
module.exports = {"seeLiveProject9":"Chairs-module--seeLiveProject9--6RCHu","sourceCodeProject9":"Chairs-module--sourceCodeProject9--2nYWW"};